module.exports = __webpack_public_path__ + "static/media/DSC01488.a855c600.jpg";